// import React, { useState, useEffect } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { addTowishlist } from '../features/products/productSlice';
// import { getUserCart, addProdToCart, syncLocalCart } from '../features/user/userSlice';
// import { base_url } from '../utils/axiosConfig';
// import axios from 'axios';
// import { IoMdCart } from "react-icons/io";
// import { FaCartShopping, FaArrowRight } from "react-icons/fa6";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";
// import { IoMdAdd } from "react-icons/io";




// const ProductCard = ({ grid, data }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const { isAuthenticated, cartProducts } = useSelector((state) => state.auth);
//   const productId = data?._id;

//   const cartItem = isAuthenticated
//     ? cartProducts.find(item => item?.ProductId?._id === productId)
//     : (JSON.parse(localStorage.getItem('cart')) || []).find(item => item?.ProductId?._id === productId);

//   const [quantity, setQuantity] = useState(cartItem?.quantity || 1);
//   const [alreadyAdded, setAlreadyAdded] = useState(!!cartItem);
//   const [isWishlisted, setIsWishlisted] = useState(false); // wishlist toggle state

//   useEffect(() => {
//     setAlreadyAdded(!!cartItem);
//     setQuantity(cartItem?.quantity || 1);
//   }, [cartItem]);

//   // Wishlist toggle function
//   const addToWish = (id, e) => {
//     e.stopPropagation();
//     if (!isAuthenticated) return toast.info('Login to add to wishlist');
//     dispatch(addTowishlist(id));
//     setIsWishlisted(!isWishlisted);
//     toast.success(!isWishlisted ? 'Added to wishlist!' : 'Removed from wishlist!');
//   };

// const handleAddToCartWithSpark = (e) => {
//   handleAddToCart(); // your original logic

//   const parent = e.currentTarget.parentElement;

//   for (let i = 0; i < 10; i++) {
//     const spark = document.createElement('span');
//     spark.className = 'fire-spark';
    
//     // Random angle and distance
//     const angle = Math.random() * 4 * Math.PI;
//     const distance = 100 + Math.random() * 2;
//     const x = Math.cos(angle) * distance;
//     const y = Math.sin(angle) * distance;

//     spark.style.setProperty('--x', `${x}px`);
//     spark.style.setProperty('--y', `${y}px`);

//     parent.appendChild(spark);

//     setTimeout(() => {
//       spark.remove();
//     }, 1000); // Remove after animation
//   }
// };



//   const handleAddToCart = async () => {
//     if (!isAuthenticated) {
//       const localCart = JSON.parse(localStorage.getItem('cart')) || [];
//       const existingIndex = localCart.findIndex(item => item.ProductId._id === data._id);

//       if (existingIndex !== -1) {
//         localCart[existingIndex].quantity += quantity;
//       } else {
//         localCart.push({
//           _id: `${data._id}_${Date.now()}`,
//           ProductId: { _id: data._id, title: data.title, images: data.images },
//           quantity,
//           price: data.CurrentPrice,
//         });
//       }

//       localStorage.setItem('cart', JSON.stringify(localCart));
//       dispatch(syncLocalCart(localCart));
//       toast.success('Added to cart!');
//       setAlreadyAdded(true);
//       return;
//     }

//     try {
//       const token = JSON.parse(localStorage.getItem('customer'))?.token;
//       const payload = {
//         ProductId: {
//           _id: data._id,
//           title: data.title,
//           images: data.images,
//           price: data.CurrentPrice,
//         },
//         quantity: cartItem ? cartItem.quantity + quantity : quantity,
//         price: data.CurrentPrice,
//       };
//       await dispatch(addProdToCart(payload)).unwrap();
//       dispatch(getUserCart());
//       toast.success('Added to cart!');
//       setAlreadyAdded(true);
//     } catch (err) {
//       toast.error('Error adding to cart');
//     }
//   };

//   const updateQuantityLocal = (newQty) => {
//     const localCart = JSON.parse(localStorage.getItem('cart')) || [];
//     const updated = localCart.map(item =>
//       item.ProductId._id === data._id ? { ...item, quantity: newQty } : item
//     );
//     localStorage.setItem('cart', JSON.stringify(updated));
//     dispatch(syncLocalCart(updated));
//     setQuantity(newQty);
//   };

//   const increaseQuantity = () => {
//     const newQty = quantity + 1;
//     setQuantity(newQty);
//     if (isAuthenticated) {
//       updateQuantityAPI(newQty);
//     } else {
//       updateQuantityLocal(newQty);
//     }
//   };

//   const decreaseQuantity = () => {
//     const newQty = Math.max(1, quantity - 1);
//     setQuantity(newQty);
//     if (isAuthenticated) {
//       updateQuantityAPI(newQty);
//     } else {
//       updateQuantityLocal(newQty);
//     }
//   };

//   const updateQuantityAPI = async (newQty) => {
//     try {
//       const token = JSON.parse(localStorage.getItem('customer'))?.token;
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       await axios.put(`${base_url}user/updatecart`, {
//         ProductId: data._id,
//         quantity: newQty,
//         price: data.CurrentPrice
//       }, config);
//       dispatch(getUserCart());
//     } catch (err) {
//       toast.error('Failed to update quantity');
//     }
//   };

//   const handleRemoveLocal = () => {
//     const localCart = JSON.parse(localStorage.getItem('cart')) || [];
//     const updated = localCart.filter(item => item.ProductId._id !== data._id);
//     localStorage.setItem('cart', JSON.stringify(updated));
//     dispatch(syncLocalCart(updated));
//     toast.success('Removed from cart');
//     setAlreadyAdded(false);
//     setQuantity(1);
//   };

//   return (
//     <div className={`col-12 col-sm-6 col-md-${grid} mb-3`}>
//       <div className="card h-100 shadow-sm border-0">
//         <button
//           onClick={(e) => addToWish(data._id, e)}
//           className="btn btn-sm position-absolute top-0 end-0 m-2 bg-white rounded-circle shadow-sm"
//         >
//           {isWishlisted ? (
//             <FaHeart className="text-danger" />
//           ) : (
//             <CiHeart />
//           )}
//         </button>

//         <Link to={`/product/${data._id}`} style={{ textDecoration: 'none' }}>
//           <img
//             src={`${base_url}${data.images?.[0]?.url}`}
//             alt={data.title}
//             className="card-img-top"
//             style={{ height: '150px', objectFit: 'contain' }}
//           />
//         </Link>

//         <div className="card-body p-2 d-flex flex-column">
//           <h6 className="card-title">{data.title}</h6>
//           <div className="mb-2">
//             <strong>₹{data.CurrentPrice}</strong>
//           </div>

//           <div className="mt-auto d-flex justify-content-between">
//             {alreadyAdded ? (
//               <div className="d-flex align-items-center border rounded">
//                 <button onClick={decreaseQuantity} className="btn btn-sm">−</button>
//                 <span>{quantity}</span>
//                 <button onClick={increaseQuantity} className="btn btn-sm"><IoMdAdd /></button>
//                 <button onClick={handleRemoveLocal} className="btn btn-sm text-danger"><MdDelete /></button>
//               </div>
//             ) : (
//               <div className="spark-button-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
//   <button onClick={handleAddToCartWithSpark} className="btn btn-sm btn-primary">
//     <IoMdCart /> Add
//   </button>
// </div>

//             )}
//             {alreadyAdded && (
//               <Link to="/cart" className="btn btn-sm btn-outline-success">
//                 <FaCartShopping /> <FaArrowRight />
//               </Link>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;


import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { addTowishlist } from '../features/products/productSlice';
import { getUserCart, addProdToCart, syncLocalCart } from '../features/user/userSlice';
import { base_url } from '../utils/axiosConfig';
import axios from 'axios';
import { IoMdCart } from "react-icons/io";
import { FaCartShopping, FaArrowRight } from "react-icons/fa6";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoMdAdd, IoMdFlash } from "react-icons/io";

const ProductCard = ({ grid, data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const { isAuthenticated, cartProducts, wishlist, user } = useSelector((state) => state.auth);

  const productId = data?._id || '';
  const cartItem = isAuthenticated
    ? cartProducts.find(item => item?.ProductId?._id === productId)
    : (JSON.parse(localStorage.getItem('cart')) || []).find(item => item?.ProductId?._id === productId);

  const [quantity, setQuantity] = useState(cartItem?.quantity || 1);
  const [alreadyAdded, setAlreadyAdded] = useState(!!cartItem);
  const [isWishlisted, setIsWishlisted] = useState(
    Array.isArray(wishlist) && wishlist.length > 0
      ? wishlist.some(item => item?._id === productId)
      : false
  );
  const [cartItems, setCartItems] = useState(
    isAuthenticated ? cartProducts : JSON.parse(localStorage.getItem('cart')) || []
  );

  // 🔹 Get role (either from redux or localStorage)
  const role = user?.role || JSON.parse(localStorage.getItem('customer'))?.role;

  useEffect(() => {
    setAlreadyAdded(!!cartItem);
    setQuantity(cartItem?.quantity || 1);
    setCartItems(isAuthenticated ? cartProducts : JSON.parse(localStorage.getItem('cart')) || []);
    setIsWishlisted(
      Array.isArray(wishlist) && wishlist.length > 0
        ? wishlist.some(item => item?._id === productId)
        : false
    );
  }, [cartItem, wishlist, productId, isAuthenticated, cartProducts]);

  if (!data || !data._id) {
    console.warn("ProductCard received invalid data:", data);
    return null;
  }

  const finalPrice = data.offerPrice && data.offerPrice > 0 ? data.offerPrice : data.CurrentPrice;
  const gstPercent = parseFloat(data.gst || '0');
  const gstAmount = (finalPrice * gstPercent) / 100;

  // 🔹 Wishlist
  const addToWish = async (id, e) => {
    e.stopPropagation();

    if (!isAuthenticated) {
      toast('Please Login to add to wishlist', { icon: '🔐' });
      return;
    }

    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot add products to wishlist.");
      return;
    }

    try {
      await dispatch(addTowishlist(id)).unwrap();
      const wasWishlisted = isWishlisted;
      setIsWishlisted(!isWishlisted);
      toast.success(wasWishlisted ? 'Removed from wishlist!' : 'Added to wishlist!');
    } catch (error) {
      console.log(error);
      toast.error("Failed to update wishlist.");
    }
  };

  // 🔹 Add to cart with sparks
  const handleAddToCartWithSpark = (e) => {
    handleAddToCart();

    const parent = e.currentTarget.parentElement;
    for (let i = 0; i < 10; i++) {
      const spark = document.createElement('span');
      spark.className = 'fire-spark';
      const angle = Math.random() * 4 * Math.PI;
      const distance = 100 + Math.random() * 2;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;

      spark.style.setProperty('--x', `${x}px`);
      spark.style.setProperty('--y', `${y}px`);
      parent.appendChild(spark);
      setTimeout(() => spark.remove(), 1000);
    }
  };

  // 🔹 Add to Cart
  const handleAddToCart = async () => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot add products to cart.");
      return;
    }

    setLoading(true);

    if (!isAuthenticated) {
      const localCart = JSON.parse(localStorage.getItem('cart')) || [];
      const existingIndex = localCart.findIndex(item => item.ProductId._id === data._id);

      if (existingIndex !== -1) {
        localCart[existingIndex].quantity += quantity;
      } else {
        localCart.push({
          _id: `${data._id}_${Date.now()}`,
          ProductId: {
            _id: data._id,
            title: data.title,
            images: data.images,
            price: finalPrice,
            originalPrice: data.CurrentPrice,
            offerPrice: data.offerPrice,
            gst: data.gst || '0',
          },
          quantity,
          price: finalPrice,
          gst: data.gst || '0',
        });
      }

      localStorage.setItem('cart', JSON.stringify(localCart));
      dispatch(syncLocalCart(localCart));
      setCartItems(localCart);
      toast.success('Added to cart!');
      setAlreadyAdded(true);
      setLoading(false);
      return;
    }

    try {
      const payload = {
        ProductId: {
          _id: data._id,
          title: data.title,
          images: data.images,
          price: finalPrice,
          originalPrice: data.CurrentPrice,
          offerPrice: data.offerPrice,
          gst: data.gst || '0',
        },
        quantity: cartItem ? cartItem.quantity + quantity : quantity,
        price: finalPrice,
      };
      await dispatch(addProdToCart(payload)).unwrap();
      dispatch(getUserCart());
      toast.success('Added to cart!');
      setAlreadyAdded(true);
    } catch (err) {
      toast.error('Error adding to cart');
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Buy Now
  const handleBuyNow = async () => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot purchase products.");
      return;
    }

    setLoading(true);
    await handleAddToCart();
    navigate("/cart");
    setLoading(false);
  };

  // 🔹 Local quantity update
  const updateQuantityLocal = (newQty) => {
    const localCart = JSON.parse(localStorage.getItem('cart')) || [];
    const updated = localCart.map(item =>
      item.ProductId._id === data._id ? { ...item, quantity: newQty } : item
    );
    localStorage.setItem('cart', JSON.stringify(updated));
    dispatch(syncLocalCart(updated));
    setCartItems(updated);
    setQuantity(newQty);
  };

  const increaseQuantity = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
    if (isAuthenticated) {
      updateQuantityAPI(newQty);
    } else {
      updateQuantityLocal(newQty);
    }
  };

  const decreaseQuantity = () => {
    const newQty = Math.max(1, quantity - 1);
    setQuantity(newQty);
    if (isAuthenticated) {
      updateQuantityAPI(newQty);
    } else {
      updateQuantityLocal(newQty);
    }
  };

  const updateQuantityAPI = async (newQty) => {
    try {
      const token = JSON.parse(localStorage.getItem('customer'))?.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.put(`${base_url}user/updatecart`, {
        ProductId: data._id,
        quantity: newQty,
        price: finalPrice,
      }, config);
      dispatch(getUserCart());
    } catch (err) {
      toast.error('Failed to update quantity');
    }
  };

  const handleRemove = async (cartItemId) => {
    if (isAuthenticated) {
      try {
        const token = JSON.parse(localStorage.getItem('customer'))?.token;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };

        await axios.delete(`${base_url}user/delete-product-cart`, {
          ...config,
          data: { cartItemId },
        });

        const updatedCart = cartProducts.filter(item => item._id !== cartItemId);
        setCartItems(updatedCart);
        toast.success('Item removed!');
        dispatch(getUserCart());
        setAlreadyAdded(false);
      } catch (error) {
        console.error('Error removing item:', error);
        toast.error('Error removing item.');
      }
    } else {
      const localCart = JSON.parse(localStorage.getItem('cart')) || [];
      const updatedCart = localCart.filter(item => item._id !== cartItemId);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      setCartItems(updatedCart);
      dispatch(syncLocalCart(updatedCart));
      toast.success('Item removed from local cart!');
      setAlreadyAdded(false);
    }
  };

  return (
    <div className={`col-6 col-sm-6 col-md-${grid} mb-2`}>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="card h-100 shadow-sm border-0" style={{ padding: '8px' }}>
        <button
          onClick={(e) => addToWish(data._id, e)}
          className="btn btn-sm position-absolute top-0 end-0 m-1 bg-white rounded-circle shadow-sm"
          style={{ padding: '4px' }}
        >
          {isWishlisted ? <FaHeart className="text-danger" size={14} /> : <CiHeart size={14} />}
        </button>

        <Link to={`/product/${data._id}`} style={{ textDecoration: 'none' }}>
          <img
            src={`${base_url}${data.images?.[0]?.url}`}
            alt={data.title}
            className="card-img-top"
            style={{ height: '100px', objectFit: 'contain' }}
          />
        </Link>

        <div className="card-body p-1 d-flex flex-column">
        <div className="mb-1" style={{ fontSize: '0.8rem' }}>
            {data.offerPrice && data.offerPrice < data.CurrentPrice ? (
              <>
                <strong className="text-success" style={{fontSize: '17px'}}>
                  ₹{data.offerPrice.toLocaleString('en-IN')}
                </strong>{' '}
                <small className="text-danger" style={{ textDecoration: 'line-through' }}>
                  ₹{data.CurrentPrice.toLocaleString('en-IN')}
                </small>
                <small className="text-success fw-bold ms-1" >
                  {Math.round(((data.CurrentPrice - data.offerPrice) / data.CurrentPrice) * 100)}% OFF
                </small>
              </>
            ) : (
              <strong>₹{data.CurrentPrice.toLocaleString('en-IN')}</strong>
            )}
          </div>
          <h6
            className="card-title text-small"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              whiteSpace: 'normal',
              fontSize: '0.85rem',
              lineHeight: '1.2',
              marginBottom: '0.5rem',
            }}
          >
            {data.title}
          </h6>

          

          <div className="mt-auto d-flex justify-content-between align-items-center">
            {alreadyAdded ? (
              <div className="d-flex align-items-center border rounded" style={{ fontSize: '0.75rem' }}>
                <button onClick={decreaseQuantity} className="btn btn-sm p-1">−</button>
                <span className="px-2">{quantity}</span>
                <button onClick={increaseQuantity} className="btn btn-sm p-1"><IoMdAdd size={14} /></button>
                <button
                  onClick={() => handleRemove(cartItem?._id)}
                  className="btn btn-sm text-danger p-1"
                >
                  <MdDelete size={14} />
                </button>
              </div>
            ) : (
              <div
                className="spark-button-wrapper d-flex gap-1"
                style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
              >
                <button
                  onClick={handleAddToCartWithSpark}
                  className="btn btn-sm text-light"
                  style={{ backgroundColor: "#ffa515ff", borderColor: "orange", fontWeight: '500', fontSize: '0.75rem', padding: '4px 8px' }}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Adding...
                    </>
                  ) : (
                    <>
                      <IoMdCart className="me-1" size={14} /> Add to cart
                    </>
                  )}
                </button>

                <button
                  onClick={handleBuyNow}
                  className="btn btn-sm text-light"
                  style={{ backgroundColor: "#ff5c0bff", borderColor: "orange", fontWeight: '500', fontSize: '0.75rem', padding: '4px 8px' }}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <IoMdFlash className="me-1" size={14} /> Buy Now
                    </>
                  )}
                </button>
              </div>
            )}
            {alreadyAdded && (
              <Link to="/cart" className="btn btn-sm btn-outline-success" style={{ fontSize: '0.75rem', padding: '4px 8px' }}>
                <FaCartShopping size={12} /> <FaArrowRight size={12} />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;